export default "__VITE_ASSET__CBqq57Kl__"